export class DesignatedDoctorInformation {
  /**
   * 指定医番号
   * typeCodeをenumにしたいところだが、マスタに文字列で格納されているのと
   * フォーマット内部に文字列で入ってしまっているので、enumにはしない
   * （マスタの変更に合わせてコードを変える必要が出てきてしまうため）
   */
  constructor(
    /**
     * typeCodeはマスタとフォーマットに埋め込まれている。
     * 徳島時点ではSHOUNIMANSEIとRINCHOの2種類が確認されている
     * 東大にて身体障害者指定医、難病指定医を追加。
     * 身体障害者指定医は指定医番号を持たないが、特定の資格として医師が持っている
     */
    public readonly userId: string,
    public readonly typeCode: string,
    public readonly typeName: string,
    public readonly doctorNumber: string,
    public readonly startDate: string,
    public readonly endDate: string,
  ) {
    this.userIdAsUpper = !!userId ? userId.toUpperCase() : userId;
  }

  public readonly userIdAsUpper: string;
}
